import {
  CANCEL_INTEGRATION_REQUEST,
  CHANGE_WIZARD_INDEX,
  FETCH_SLACK_DATA_REQUEST,
  FETCH_TEAMS_DATA_REQUEST,
  SELECT_APP,
  UPDATE_COLLABORATION_APP_ALERTS_REQUEST,
  UPDATE_NOTIFICATIONS_REQUEST,
  UPDATE_WEBHOOK_URL,
} from './constants'

const changeWizardIndex = (wizardIndex) => ({
  type: CHANGE_WIZARD_INDEX,
  payload: { wizardIndex },
})

const selectAppIntegration = (appValue) => ({
  type: SELECT_APP,
  payload: { appValue },
})

export const fetchSlackData = () => ({
  type: FETCH_SLACK_DATA_REQUEST.INITIATE,
})
export const fetchSlackDataSuccess = (data) => ({
  type: FETCH_SLACK_DATA_REQUEST.SUCCESS,
  payload: { data },
})
export const fetchSlackDataError = (error) => ({
  type: FETCH_SLACK_DATA_REQUEST.ERROR,
  error,
})
export const fetchSlackDataCancel = () => ({
  type: FETCH_SLACK_DATA_REQUEST.CANCEL,
})

export const fetchTeamsData = () => ({
  type: FETCH_TEAMS_DATA_REQUEST.INITIATE,
})
export const fetchTeamsDataSuccess = (data) => ({
  type: FETCH_TEAMS_DATA_REQUEST.SUCCESS,
  payload: { data },
})
export const fetchTeamsDataError = (error) => ({
  type: FETCH_TEAMS_DATA_REQUEST.ERROR,
  error,
})
export const fetchTeamsDataCancel = () => ({
  type: FETCH_TEAMS_DATA_REQUEST.CANCEL,
})

const updateWebhookUrl = (val) => ({
  type: UPDATE_WEBHOOK_URL,
  payload: { val },
})

export const updateCollaborationAppAlerts = (alerts) => ({
  type: UPDATE_COLLABORATION_APP_ALERTS_REQUEST.INITIATE,
  payload: { alerts },
})
export const updateCollaborationAppAlertsSuccess = () => ({
  type: UPDATE_COLLABORATION_APP_ALERTS_REQUEST.SUCCESS,
})
export const updateCollaborationAppAlertsError = (error) => ({
  type: UPDATE_COLLABORATION_APP_ALERTS_REQUEST.ERROR,
  error,
})

export const updateNotifications = () => ({
  type: UPDATE_NOTIFICATIONS_REQUEST.INITIATE,
})
export const updateNotificationsSuccess = () => ({
  type: UPDATE_NOTIFICATIONS_REQUEST.SUCCESS,
})
export const updateNotificationsError = (error) => ({
  type: UPDATE_NOTIFICATIONS_REQUEST.ERROR,
  error,
})

export const cancelIntegration = () => ({
  type: CANCEL_INTEGRATION_REQUEST.INITIATE,
})
export const cancelIntegrationSuccess = () => ({
  type: CANCEL_INTEGRATION_REQUEST.SUCCESS,
})
export const cancelIntegrationError = (error) => ({
  type: CANCEL_INTEGRATION_REQUEST.ERROR,
  error,
})

export default {
  // to props
  changeWizardIndex,
  selectAppIntegration,
  fetchSlackData,
  fetchSlackDataCancel,
  fetchTeamsData,
  fetchTeamsDataCancel,
  updateNotifications,
  cancelIntegration,
  updateWebhookUrl,
  updateCollaborationAppAlerts,
}
